import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Alert } from 'src/app/acl-data/document/document.dto';

@Component({
    selector: 'app-system-notification-view',
    templateUrl: './system-notification-view.component.html',
    styleUrls: ['./system-notification-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SystemNotificationViewComponent implements OnChanges {
    @Input() alerts: Alert[];
    @Input() objectStore: string;
    @Input() reviewDeadlineDate: Date;

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    displayedColumns: string[] = [
        'AlertTemplateName',
        'AlertDueDate',
        'AlertSendDate',
        'AlertCancelled',
    ];
    dataSource;

    displayChange() {
        // console.log('DisplayChange');
        if (this.alerts) {
            this.dataSource = new MatTableDataSource<Alert>(
                this.alerts
                    .filter(v => !!v.propertiesObj.AlertSystem)
                    .sort((a, b) =>
                        a.propertiesObj.DateCreated <
                        b.propertiesObj.DateCreated
                            ? 1
                            : -1
                    )
            );
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        }
    }

    ngOnChanges() {
        this.displayChange();
    }
}
